// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QZAfL","icon":"styles_icon__oRXvd"};